import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import Dashboard from './pages/dashboard';
import Login from './pages/login';
import ProtectedRoute from './components/protectedroute';
import Users from './pages/users';
import Bookings from './pages/bookings';
import Tickets from './pages/tickets';
import Categories from './pages/categories';
import Programs from './pages/programs';
import Startups from './pages/startups';
import Booths from './pages/booths';
import Content from './pages/content';
import Feedback from './pages/feedback';
import CallLogs from './pages/callLogs';
import Notifications from './pages/notifications';
import Error from './pages/error';

const Routing = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Login />} path="/" />
        <Route element={<Login />} path="/login" />

        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />

        <Route
          path="/users"
          element={
            <ProtectedRoute>
              <Users />
            </ProtectedRoute>
          }
        />

        <Route
          path="/bookings"
          element={
            <ProtectedRoute>
              <Bookings />
            </ProtectedRoute>
          }
        />

        <Route
          path="/tickets"
          element={
            <ProtectedRoute>
              <Tickets />
            </ProtectedRoute>
          }
        />

        <Route
          path="/categories"
          element={
            <ProtectedRoute>
              <Categories />
            </ProtectedRoute>
          }
        />

        <Route
          path="/programs"
          element={
            <ProtectedRoute>
              <Programs />
            </ProtectedRoute>
          }
        />

        <Route
          path="/startups"
          element={
            <ProtectedRoute>
              <Startups />
            </ProtectedRoute>
          }
        />

        <Route
          path="/booths"
          element={
            <ProtectedRoute>
              <Booths />
            </ProtectedRoute>
          }
        />

        <Route
          path="/content"
          element={
            <ProtectedRoute>
              <Content />
            </ProtectedRoute>
          }
        />

        <Route
          path="/content-management"
          element={
            <ProtectedRoute>
              <Content />
            </ProtectedRoute>
          }
        />

        <Route
          path="/feedback"
          element={
            <ProtectedRoute>
              <Feedback />
            </ProtectedRoute>
          }
        />

        <Route
          path="/notifications"
          element={
            <ProtectedRoute>
              <Notifications />
            </ProtectedRoute>
          }
        />

        <Route
          path="/call-logs"
          element={
            <ProtectedRoute>
              <CallLogs />
            </ProtectedRoute>
          }
        />

        <Route path="*" element={<Error />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Routing;
